import { SERVICES as INTAKE_SERVICES } from "@/components/intake/options";

const SERVICE_TITLES = Object.fromEntries(INTAKE_SERVICES.map((s) => [s.id, s.title]));

export function intakeSections(intake) {
  const c = intake.contact || {};
  const p = intake.project || {};
  const w = intake.website || {};
  const b = intake.brand || {};
  const bud = intake.budget || {};
  const f = intake.final || {};
  const sections = [
    { title: "Contact", rows: [["Business", c.company], ["Website", c.website], ["Heard via", c.referralSource]] },
    { title: "Services", rows: [["Selected", (intake.services || []).map((id) => SERVICE_TITLES[id] || id).join(", ")]] },
    { title: "Project", rows: [["Vision", p.description], ["Goals", (p.goals || []).join(", ")], ["Existing materials", p.existingMaterials]] },
  ];
  if (w.hasWebsite || w.websiteType || (w.features || []).length) {
    sections.push({
      title: "Website",
      rows: [
        ["Has website", w.hasWebsite], ["Current URL", w.currentWebsite], ["Type", w.websiteType],
        ["Pages", w.pageCount], ["Features", (w.features || []).join(", ")], ["Content needed", w.contentNeeded],
      ],
    });
  }
  sections.push(
    { title: "Brand & Content", rows: [["Logo", b.logo], ["Brand colors", b.brandColors], ["Photos/videos", b.media], ["Guidelines", b.brandGuidelines]] },
    { title: "Budget & Timeline", rows: [["Budget", bud.estimatedBudget], ["Start", bud.timeline], ["Deadline", bud.hasDeadline === "Yes" ? bud.deadline : bud.hasDeadline]] },
    { title: "Contact Preference", rows: [["Contact via", (f.contactPreference || []).join(", ")], ["Best time", f.preferredContactTime], ["Notes", f.additionalDetails]] },
  );
  return sections
    .map((s) => ({ ...s, rows: s.rows.filter(([, v]) => v && String(v).trim()) }))
    .filter((s) => s.rows.length > 0);
}
